const footerCopyrightDate = new Date();
$('#footerCopyrightYear').text(footerCopyrightDate.getFullYear());

// eslint-disable-next-line no-unused-vars
const checkUsOutSlideObject = new Swiper('#check_us_slides', {
  slidesPerView: 'auto',
  spaceBetween: 20,
  freeMode: true,
  observer: true,
  observeParents: true,
  observeSlideChildren: true,
  navigation: {
    nextEl: '#check_us_right_arrow',
    prevEl: '#check_us_left_arrow'
  }
});

$(document).on('click', '#check_us_right_arrow', function () {
  updateCheckUsSlider();
});

$(document).on('click', '#check_us_left_arrow', function () {
  updateCheckUsSlider();
});

checkUsOutSlideObject.on('sliderMove', function () {
  updateCheckUsSlider();
});

function updateCheckUsSlider () {
  checkUsOutSlideObject.updateSlides();
  checkUsOutSlideObject.updateSize();
}

$(window).on('scroll', function () {
  if ($(this).scrollTop() > 350) {
    $('#backToTop').fadeIn('slow');
  } else {
    $('#backToTop').fadeOut('slow');
  }
});

$('#backToTop').on('click', function () {
  $('html, body').animate({
    scrollTop: 0
  }, 1500, 'easeInOutExpo');
  return false;
});
